module.exports = __webpack_public_path__ + "img/0022.4a906ccf.jpg";